module.exports = __webpack_public_path__ + "static/media/Union.65837938.svg";